import {
    type GetNewsByIdResponseType,
    type GetNewsByIdRequestType
} from "./type";
import {
    request
} from "../request";

const GetNewsById = async (params: GetNewsByIdRequestType): Promise<GetNewsByIdResponseType> => {
    return await request<GetNewsByIdResponseType>("/news/getNewsById", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetNewsById;
